import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Biller } from "../../../../core/models/users/billers/billerDto";
import { UserHeader } from "../../../../core/models/users/user-header";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
@Component({
  selector: "jni-biller-listing",
  templateUrl: "./biller-listing.component.html",
  imports: [
    TableModule,
    CommonModule,
    InputTextModule,
    ButtonModule,
    CardModule,
  ],
  styleUrls: ["./biller-listing.component.scss"],
})
export class BillerListingComponent {
  @Input() parent!: FormGroup;
  @Input() BillerListing!: Biller[];
  @Output() updateUser = new EventEmitter<UserHeader>();

  onEditRow(event: UserHeader) {
    event.userType = "Biller";
    this.updateUser.emit(event);
  }
}
